<template>
    <div class="side">
        <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        :router="true">
            <el-menu-item index="/police/house/list">
                <span slot="title">房源</span>
            </el-menu-item>
            <el-menu-item index="/police/housestate/list">
                <span slot="title">入住登记</span>
            </el-menu-item>
            <el-menu-item index="/police/calendar/calendar">
                <span slot="title">房态日历</span>
            </el-menu-item>
            <el-menu-item index="/police/landlord/list">
                <span slot="title">房东</span>
            </el-menu-item>
            <el-menu-item index="/police/renters/list">
                <span slot="title">房客</span>
            </el-menu-item>
            <el-menu-item index="/police/statics/index">
                <span slot="title">统计</span>
            </el-menu-item>
            <el-menu-item index="/police/patrol/index">
                <span slot="title">巡查</span>
            </el-menu-item>
            <el-menu-item index="/acconut/list">
                <span slot="title">用户</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    name: 'PoliceAside',
    data() {
        return {

        }
    },
    methods: {
        
    },
}
</script>

<style lang="scss" scoped>
.el-menu{
    border-right: none;
}
</style>